import { render, staticRenderFns } from "./LoanCollateralAssetSecuritiesFieldsEdit.vue?vue&type=template&id=2fcc3906&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetSecuritiesFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetSecuritiesFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetSecuritiesFieldsEdit.vue?vue&type=style&index=0&id=2fcc3906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc3906",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetSecuritiesFieldsEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports